import { render, staticRenderFns } from "./TextControl.vue?vue&type=template&id=339f5eae&scoped=true&"
import script from "./TextControl.vue?vue&type=script&lang=ts&"
export * from "./TextControl.vue?vue&type=script&lang=ts&"
import style0 from "./TextControl.vue?vue&type=style&index=0&id=339f5eae&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "339f5eae",
  null
  
)

export default component.exports